<template>
  <div class="header-wrapper">
    <div class="header-content container">
      <div class="header-content-text">
        <h1>EYEJACK<br /><span id="gradient">TRAITZ</span></h1>
        <p>
          Generative Traitz tool that <br />gives full control to the Artist
        </p>
      </div>
      <div class="header-content-video">
        <video loop autoplay muted playsinline >
          <source src="@/assets/traitz-header.mp4" type="video/mp4" />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style lang="scss" scoped>
@import "@/styles/styles.scss";

.header-wrapper {
  width: 100vw;
  height: calc(100vh - 80px);
  .header-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    @include media("<tablet") {
      align-items: center;

    }
    height: 100%;

    &-text {
      margin-top: 70px;
      @include media(">=tablet") {
        margin-top: 0;
      }
      h1 {
        font-weight: 900;
        font-size: 52px;
        @include media(">=tablet") {
          font-size: 68px;
        }
      }
      #gradient {
        background: -webkit-linear-gradient(left, #e36860, #e6a857);
        background: -o-linear-gradient(right, #e36860, #e6a857);
        background: -moz-linear-gradient(right, #e36860, #e6a857);
        background: linear-gradient(to right, #e36860, #e6a857);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      p {
        margin: 50px 0 65px 0;
        font-size: 26px;
        @include media(">=tablet") {
          font-size: 36px;
        }
      }
      &-logos {
        display: flex;
        align-items: center;
        img:first-child {
          height: 25px;
        }
        img {
          height: 10px;
          width: auto;
          margin-right: 28px;
        }

        @include media(">=tablet") {
          img:first-child {
            height: 35px;
          }
          img {
            height: 14px;
            width: auto;
            margin-right: 28px;
          }
        }
      }
    }
    &-video {
      margin-top: -70px;
        z-index: -1;
      @include media(">=tablet") {
        position: absolute;
        top: 0;
        left: 40%;
        height: 90vh;
        margin-top: 0;
      }
      @include media(">=950px") {
        height: 100vh;
        left: 30%;
      }
      video {
        width: 100%;
        height: 100%;
        @include media("<650px") {
          max-width: 600px;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
